type Props = {
  className?: string
  width?: number
  height?: number
  color?: string
}

export const HexagonIcon = ({ className, width = 11, height = 13, color }: Props) => {
  return (
    <span className={className}>
      <svg width={width} height={height} viewBox="0 0 11 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M10.8333 9.66556V3.41549L5.4167 0.290527L0 3.41549V9.66556L5.4167 12.7905L10.8333 9.66556Z"
          fill={color ?? 'url(#paint0_linear_7208_1368)'}
        />
        <defs>
          <linearGradient
            id="paint0_linear_7208_1368"
            x1="5.41667"
            y1="0.290527"
            x2="5.41667"
            y2="23.728"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B7ECDA" />
            <stop offset="1" stopColor="#40AD87" />
          </linearGradient>
        </defs>
      </svg>
    </span>
  )
}
